<template>
  <div class="listing-card">
    <div v-if="variant === 'page'" class="little-title">
      <img src="@/assets/images/编组 26@2x.png" class="icon-title" alt="">
      {{ title }}
    </div>
    <div class="detail-form bg mt10">
      <el-row>
        <el-col :span="12">
          <el-form-item label="入驻名称：">
            <GsVal :value="company.companyName" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="所属企业：">
            <EnterpriseLink :id="resolvedEnterpriseId" :name="resolvedEnterpriseName" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item :label="isDemand ? '数据需求量：' : '数量说明：'">
            <GsVal :value="company.dataRequirement" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="isDemand ? '需求行业：' : '服务行业：'">
            <GsVal :value="industryLabel" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="地点：">
            <GsVal :value="company.address" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12"><el-form-item label="联系人："><GsVal :value="company.name" /></el-form-item></el-col>
        <el-col :span="12"><el-form-item label="职务："><GsVal :value="company.job" /></el-form-item></el-col>
      </el-row>
      <el-row>
        <el-col :span="12"><el-form-item label="联系电话："><GsVal :value="company.phone" /></el-form-item></el-col>
        <el-col :span="12"><el-form-item label="邮箱："><GsVal :value="company.mailbox" /></el-form-item></el-col>
      </el-row>
      <el-row>
        <el-col :span="12"><el-form-item label="产品标签："><GsVal :value="company.companyProduct" /></el-form-item></el-col>
        <el-col :span="12"><el-form-item label="发布时间："><GsVal :value="company.createTime" /></el-form-item></el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item :label="isDemand ? '数据需求描述：' : '数据服务内容：'">
            <GsVal :value="company.requireMent" />
          </el-form-item>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import GsVal from '@/components/GsVal/index.vue'
import EnterpriseLink from '@/components/EnterpriseLink/index.vue'

export default {
  name: 'ListingCard',
  components: { GsVal, EnterpriseLink },
  props: {
    company: {
      type: Object,
      default: () => ({})
    },
    businessOptions: {
      type: Array,
      default: () => []
    },
    isDemand: {
      type: Boolean,
      default: false
    },
    enterpriseId: {
      type: [String, Number],
      default: ''
    },
    enterpriseName: {
      type: String,
      default: ''
    },
    variant: {
      type: String,
      default: 'page'
    }
  },
  computed: {
    title() {
      return '入驻信息'
    },
    resolvedEnterpriseId() {
      return this.enterpriseId || (this.company && this.company.enterpriseId) || ''
    },
    resolvedEnterpriseName() {
      return this.enterpriseName || (this.company && (this.company.enterpriseName || this.company.enterpriseAbbreviation)) || ''
    },
    industryLabel() {
      const value = this.company && this.company.businessType
      if (!value) return ''
      const hit = (this.businessOptions || []).find((item) => String(item.value) === String(value))
      return (hit && hit.label) || value
    }
  }
}
</script>

<style scoped>
.listing-card {
  margin-top: 0;
}
.icon-title {
  width: 18px;
  height: 18px;
  margin-right: 6px;
  vertical-align: middle;
}
.little-title {
  display: flex;
  align-items: center;
  font-weight: 700;
}
@media (max-width: 960px) {
  .listing-card :deep(.el-col) {
    max-width: 100% !important;
    flex: 0 0 100% !important;
  }
  .listing-card :deep(.el-form-item) {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    margin-bottom: 10px;
  }
  .listing-card :deep(.el-form-item__label) {
    width: auto !important;
    text-align: left !important;
    justify-content: flex-start !important;
    line-height: 1.35 !important;
    height: auto !important;
    padding: 0 0 2px !important;
    font-size: 12px !important;
    color: #64748b !important;
  }
  .listing-card :deep(.el-form-item__content) {
    margin-left: 0 !important;
    font-size: 13px !important;
    line-height: 1.45 !important;
  }
}
</style>
